import React, { useState, useImperativeHandle } from 'react';
import { Modal, Button } from 'antd';

export default React.forwardRef(function CrossUserGuide(props, ref) {
  const [curGuideStep, setCurGuideStep] = useState(1); // ENUM：1,2【第一步和第二步】
  const [showGuide, setShowGuide] = useState(false);

  useImperativeHandle(ref, () => {
    return {
      show() {
        setShowGuide(true);
      },
    };
  });

  function handleOnCancelClick() {
    setShowGuide(false);
  }

  function handleOnSureClick() {
    if (curGuideStep === 1) {
      setCurGuideStep(2);
    } else {
      handleOnCancelClick();
    }
  }

  // Dom输出
  if (!showGuide) return null;
  return (
    <Modal
      title={`新手引导`}
      className="cross-user-guide-modal-fa"
      width={682}
      bodyStyle={{
        borderTop: '1px solid rgba(0,0,0,.06)',
        borderBottom: '1px solid rgba(0,0,0,.06)',
      }}
      style={{
        top: 220,
      }}
      visible={showGuide}
      mask={true}
      maskClosable={false}
      footer={[
        <Button key="cancel" onClick={handleOnCancelClick}>
          跳过
        </Button>,
        curGuideStep === 1 && (
          <Button key="submit1" type="primary" onClick={handleOnSureClick}>
            下一步
          </Button>
        ),
        curGuideStep !== 1 && (
          <Button key="submit2" type="primary" onClick={handleOnSureClick}>
            立即体验
          </Button>
        ),
      ]}
      onCancel={handleOnCancelClick}
    >
      <div className="cross-user-guide-wrap">
        {curGuideStep === 1 ? (
          <img
            src="//img30.360buyimg.com/pop/jfs/t1/197537/9/27531/155650/637774beE77c2067b/ec9b9447eec1a478.png"
            style={{ width: 632, height: 260 }}
          />
        ) : (
          <img
            src="//img30.360buyimg.com/pop/jfs/t1/207857/8/28792/66776/637774beEf5110184/b4155bc81532d4f5.png"
            style={{ width: 632, height: 260 }}
          />
        )}
      </div>
    </Modal>
  );
});
